/* =========================================================
   IR FAQ - Enhanced with smooth animations and stagger effects
   ========================================================= */
(() => {
  const sections = document.querySelectorAll('[data-ir-faq]');
  if (!sections.length) return;

  // Animation timing constants
  const ANIMATION_DURATION = 400;
  const STAGGER_DELAY = 100;

  sections.forEach((section) => {
    const singleOpen = section.getAttribute('data-single-open') === 'true';
    const items = Array.from(section.querySelectorAll('details.ir-faq__item'));
    if (!items.length) return;

    // Add initial stagger animation on page load
    items.forEach((item, index) => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
      
      setTimeout(() => {
        item.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      }, index * STAGGER_DELAY);
    });

    // Enhanced toggle behavior with smooth animations
    items.forEach((details) => {
      details.addEventListener('toggle', (e) => {
        const answer = details.querySelector('.ir-faq__answer');
        
        if (details.open) {
          // Opening animation
          if (answer) {
            answer.style.animation = 'fadeInUp 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards';
          }
          
          // Handle single open behavior with stagger close animation
          if (singleOpen) {
            const otherOpenItems = items.filter(item => item !== details && item.open);
            
            otherOpenItems.forEach((other, index) => {
              setTimeout(() => {
                const otherAnswer = other.querySelector('.ir-faq__answer');
                if (otherAnswer) {
                  otherAnswer.style.animation = 'fadeOutDown 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards';
                }
                
                setTimeout(() => {
                  other.removeAttribute('open');
                }, 300);
              }, index * 50); // Stagger the closing
            });
          }
        } else {
          // Closing animation
          if (answer) {
            answer.style.animation = 'fadeOutDown 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards';
          }
        }
      });

      // Add smooth hover effects with JavaScript for enhanced interaction
      const summary = details.querySelector('.ir-faq__summary');
      if (summary) {
        summary.addEventListener('mouseenter', () => {
          summary.style.transform = 'translateX(8px)';
        });
        
        summary.addEventListener('mouseleave', () => {
          summary.style.transform = 'translateX(0)';
        });
      }
    });

    // Add intersection observer for scroll-triggered animations
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const item = entry.target;
            const index = items.indexOf(item);
            
            setTimeout(() => {
              item.style.transform = 'translateY(0) scale(1)';
              item.style.opacity = '1';
            }, index * 50);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '50px'
      });

      items.forEach((item) => {
        observer.observe(item);
      });
    }
  });
})();
